<app-loader [isLoading]="isLoading"></app-loader>
<div class="header">
    <div class="top">
        <a routerLink="/home/culture/organization/">
            <h3>Organización /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>{{ isEditMode ? 'Editar organigrama' : 'Añadir organigrama' }}</h2>
            </div>
        </a>
    </div>
</div>
<div class="content form">
    <form [formGroup]="form">
        <h4>Nombre:</h4>
        <mat-form-field appearance="outline" id="title-form-field">
            <input matInput formControlName="title" placeholder="Nombre">
            @if (form.controls['title'].invalid && form.controls['title'].touched) {
            <mat-error>
                {{ isEditMode ? 'El nombre es obligatorio' : 'El título es obligatorio' }}
            </mat-error>
            }
        </mat-form-field>

        @if (isEditMode && currentImageUrl) {
        <h4>Imagen actual:</h4>
        <div class="existing-media">
            <div class="media-item">
                <div class="media-preview">
                    <img [src]="currentImageUrl" alt="Imagen del organigrama" class="media-preview">
                    <button mat-icon-button color="warn" type="button" (click)="removeImage()" class="delete-image-btn">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
                <div class="media-info">
                    <p>{{ currentImageName || 'Imagen del organigrama' }}</p>
                </div>
            </div>
        </div>

        } @else {
        <h4>Imagen:</h4>
        <app-upload-files [singleFile]="true" (filesSelected)="onFileSelected($event)"></app-upload-files>
        @if (form.controls['image'].invalid && form.controls['image'].touched && selectedFiles.length === 0) {
        <mat-error>
            <span class="mat-error">La imagen es obligatoria</span>
        </mat-error>
        }
        }
    </form>

    <div class="buttons">
        <button mat-flat-button id="action" (click)="saveOrganization()">
            {{ isEditMode ? 'Guardar cambios' : 'Guardar' }}
        </button>
        <button mat-flat-button id="cancel" routerLink="/home/culture/organization">Cancelar</button>
    </div>
</div>